import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"
import { cn } from "./utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <SwitchPrimitive.Root
            ref={ref}
            className={cn(
                "peer inline-flex h-4 w-8 shrink-0 items-center rounded-full border transition-colors focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-1",
                "data-[state=checked]:bg-green-500 data-[state=unchecked]:bg-gray-300",
                "border-gray-400",
                className
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                className={cn(
                    "pointer-events-none block h-3.5 w-3.5 rounded-full bg-white shadow-sm ring-0 transition-transform",
                    "data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-[2px]"
                )}
            />
        </SwitchPrimitive.Root>
    )
})

Switch.displayName = "Switch"

export { Switch }
